import React from 'react';
import classnames from 'classnames';
import Element from '../../../element';
import CardHeaderTitle from './title';
import CardHeaderIcon from './icon';
import styles from '../card.module.scss';

interface IProps {
    className?: string;
    children?: React.ReactNode;
}

export function CardHeader({ className, children, ...rest }: IProps) {
    return (
        <Element
            className={classnames(styles['bm-card-header'], className)}
            {...rest}
        >
            {children}
        </Element>
    );
}
CardHeader.Title = CardHeaderTitle;
CardHeader.Icon = CardHeaderIcon;

export default CardHeader;
